import React from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import Tickets from "../pages/Tickets/";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import { AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { ThemeProvider } from "../context/DarkMode";
import { NotificationSoundProvider } from "../context/NotificationSound";
import Route from "./Route";

const PrivateLayout = ({ children }) => (
  <NotificationSoundProvider>
    <WhatsAppsProvider>
      <LoggedInLayout>{children}</LoggedInLayout>
    </WhatsAppsProvider>
  </NotificationSoundProvider>
);

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <Route exact path="/" component={Dashboard} isPrivate layout={PrivateLayout} />
            <Route exact path="/tickets/:ticketId?" component={Tickets} isPrivate layout={PrivateLayout} />
            <Route exact path="/connections" component={Connections} isPrivate layout={PrivateLayout} />
            <Route exact path="/contacts" component={Contacts} isPrivate layout={PrivateLayout} />
            <Route exact path="/users" component={Users} isPrivate layout={PrivateLayout} />
            <Route exact path="/quickAnswers" component={QuickAnswers} isPrivate layout={PrivateLayout} />
            <Route exact path="/Settings" component={Settings} isPrivate layout={PrivateLayout} />
            <Route exact path="/Queues" component={Queues} isPrivate layout={PrivateLayout} />
          </Switch>
          <ToastContainer autoClose={3000} />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
